import script from "./BarChart.vue?vue&type=script&setup=true&lang=js"
export * from "./BarChart.vue?vue&type=script&setup=true&lang=js"

import "./BarChart.vue?vue&type=style&index=0&id=6ba4c840&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ba4c840"]])

export default __exports__